<template>
  <div class="boardAndLodging">
    <Header></Header>
    <Nav type="5"></Nav>
    <Toptitle title="食宿推荐"></Toptitle>
    <div class="activitiesCommunity_nav">
      <span :class="listJson.type == 8 ? ' selection ona':'ona'" @click="listJson.type = 8,getlist(),listJson.pageNo=1">美食</span>
      <span :class="listJson.type == 20 ? ' selection ona':'ona'" @click="listJson.type = 20,getlist(),listJson.pageNo=1">住宿</span>
      <span :class="listJson.type == 201 ? ' selection ona':'ona'" @click="listJson.type = 201,getlist(),listJson.pageNo=1">预定</span>
    </div>
    <div class="boardModel" v-if="list.length>0">
      <div class="board_item" v-for="(item,index) of list" :key="index" @click="goArticleDetail(item.id)">
        <div class="board_item_img">
          <img :src="item.picture" />
        </div>
        <div class="board_item_right">
          <h3 class="board_h3">{{item.title}}</h3>
          <p class="board_p1" v-if="item.subtitle">{{item.subtitle}}</p>
          <p class="board_p2" v-if="item.targetidname"><span>{{item.targetidname}}</span><!-- <i class="boder_i"></i><span></span> -->
          </p>
        </div>
      </div>
    </div>
    <div class="null" v-else>{{listJson.type != 20 ? (listJson.type==8 ?'暂无美食':'（开发中......）') : '暂无住宿'}}</div>
    <el-pagination background small layout="prev, pager, next" @current-change="handleCurrentChange" :page-size='listJson.pageSize'
      :total="totalRecord" class="newspage showInPc" :current-page="listJson.pageNo" prev-text='< 上一页' next-text='下一页 >'
      v-if="list.length>0"></el-pagination>
    <el-pagination background small layout="prev, pager, next" @current-change="handleCurrentChange" :page-size='listJson.pageSize'
      :total="totalRecord" class="newspage showInPhone" :current-page="listJson.pageNo" prev-text='<' next-text='>'
      v-if="list.length>0"></el-pagination>
    <Footer></Footer>
  </div>
</template>
<style>
  .board_item {
    margin-bottom: 20px;
  }
</style>
<script>
  import Header from './common/Header.vue'
  import Nav from './common/Nav.vue'
  import Footer from './common/Footer.vue'
  import Toptitle from './common/Toptitle.vue'
  export default {
    data() {
      return {
        totalRecord: 0,
        listJson: {
          type: 8,
          pageNo: 1,
          pageSize: 12,
        },
        list: []
      }
    },
    components: {
      Header,
      Footer,
      Nav,
      Toptitle
    },
    mounted() {
      this.getlist()
      console.log(this.listJson.type)
    },
    methods: {
      handleCurrentChange(val) {
        this.listJson.pageNo = val
        this.getlist()
      },
      goArticleDetail(id) {
        this.$router.push({
          name: 'articleDetail',
          query: {
            id: id
          }
        })
      },
      getlist() {
        this.axios.post('api/c_article/getList.do', this.qs(this.listJson))
          .then(res => {
            this.listJson.pageNo = res.data.page.pageNo
            this.totalRecord = res.data.page.totalRecord
            this.list = res.data.page.results
          })
      }
    }
  }
</script>

<style>
</style>
